import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Phone, List, X } from "@phosphor-icons/react";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { href: "/", label: "Home" },
    { href: "/about", label: "About" },
    { href: "/sales", label: "Sales" },
    { href: "/service-areas", label: "Service Areas" },
    { href: "/faq", label: "FAQ" },
    { href: "/blog", label: "Blog" },
    { href: "/contact", label: "Contact" },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-[#F7F5F0]/80 border-b border-[#E2DCD0]">
      <div className="px-6 md:px-12 lg:px-24">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3" data-testid="header-logo">
            <div className="w-10 h-10 bg-[#2C4C3B] rounded-lg flex items-center justify-center">
              <span className="text-white font-bold text-xl font-serif">L</span>
            </div>
            <div className="hidden sm:block">
              <h1 className="text-lg font-semibold text-[#1C1914] font-serif leading-tight">Legacy Liquidators</h1>
              <p className="text-xs text-[#5C564D]">Estate Sale Services</p>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`text-sm font-medium transition-colors link-underline ${
                  isActive(link.href)
                    ? "text-[#2C4C3B]"
                    : "text-[#5C564D] hover:text-[#1C1914]"
                }`}
                data-testid={`nav-link-${link.label.toLowerCase().replace(' ', '-')}`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          {/* CTA Button */}
          <div className="flex items-center gap-4">
            <a
              href="tel:2182982420"
              className="hidden md:flex items-center gap-2 bg-[#2C4C3B] hover:bg-[#1E3629] text-white px-5 py-2.5 rounded-md transition-all duration-300 text-sm font-medium"
              data-testid="header-phone-button"
            >
              <Phone weight="fill" className="w-4 h-4" />
              <span>218-298-2420</span>
            </a>

            {/* Mobile Menu */}
            <Sheet open={isOpen} onOpenChange={setIsOpen}>
              <SheetTrigger asChild>
                <button
                  className="lg:hidden p-2 text-[#1C1914] hover:bg-[#E2DCD0] rounded-md transition-colors"
                  data-testid="mobile-menu-button"
                >
                  <List className="w-6 h-6" />
                </button>
              </SheetTrigger>
              <SheetContent side="right" className="w-[300px] bg-[#F7F5F0]">
                <div className="flex flex-col gap-8 mt-8">
                  <nav className="flex flex-col gap-4">
                    {navLinks.map((link) => (
                      <Link
                        key={link.href}
                        to={link.href}
                        onClick={() => setIsOpen(false)}
                        className={`text-lg font-medium py-2 border-b border-[#E2DCD0] transition-colors ${
                          isActive(link.href)
                            ? "text-[#2C4C3B]"
                            : "text-[#5C564D] hover:text-[#1C1914]"
                        }`}
                        data-testid={`mobile-nav-link-${link.label.toLowerCase().replace(' ', '-')}`}
                      >
                        {link.label}
                      </Link>
                    ))}
                  </nav>
                  <a
                    href="tel:2182982420"
                    className="flex items-center justify-center gap-2 bg-[#2C4C3B] hover:bg-[#1E3629] text-white px-6 py-4 rounded-md transition-all duration-300 font-medium"
                    data-testid="mobile-phone-button"
                  >
                    <Phone weight="fill" className="w-5 h-5" />
                    <span>Call 218-298-2420</span>
                  </a>
                </div>
              </SheetContent>
            </Sheet>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
